import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone)
dayjs.extend(advancedFormat);


const generateItemDetails = async (item, state) => {
  dayjs.tz.setDefault('UTC');
  let idx;
  let resource;
  const { optimisticReRender, optimisticLiveSchedule, liveSchedule } = state;
  if (optimisticReRender) {
    idx = optimisticLiveSchedule.findIndex((elem) => {
      return elem.rId === item.group;
    });
    resource = optimisticLiveSchedule[idx];
  }
  else {
    idx = liveSchedule.liveSchedule.findIndex((elem) => {
      return elem.rId === item.group;
    });
    resource = liveSchedule.liveSchedule[idx];
  }
  let itemDetails;
  if (item.itemType === 'assignment') {
    const startTime = dayjs(item.start_time).format('h:mm a, MMM Do');
    const endTime = dayjs(item.end_time).format('h:mm a, MMM Do');
    let assignment;

    //NOTE: we may need to find a better way to check this than checking the color
    if (item.backgroundColor === "#ffcc66" || item.backgroundColor === "#c3e2fa" || item.backgroundColor === "gray") { // if assignment has a gold background color it must be on-call / stand by
      assignment = resource.dayTypes[item.rdtId].tour && resource.dayTypes[item.rdtId].tour.assignments[item.id] ? resource.dayTypes[item.rdtId].tour.assignments[item.id] : resource.dayTypes[item.rdtId].assignment;
    } else assignment = resource.dayTypes[item.rdtId].tour.assignments[item.id];
    const { service, costObject, costObjectNumber, comment,
      activityType, description, requestNumber, myAssignmentComment, costOnFacility, isApproved, altResource, altType, assignmentContract, overtimeReason} = assignment;
    itemDetails = {
      itemType: item.itemType,
      title: 'Assignment Details',
      comment,
      description,
      myAssignmentComment,
      startTime,
      endTime,
      service,
      costObject,
      costObjectNumber,
      requestNumber,
      resourceClass: item.resourceClass,
      costOnFacility,
      isApproved,
      altResource,
      altType,
      assignmentContract,
      overtimeReason
    };
  } else if (item.itemType === 'off-request') {
    // For day off requests that go over multiple days
    let tempId;
    if (typeof (item.id) === 'string' && item.id.includes('-') && item.itemType === 'off-request') {
      tempId = item.id.split('-')[0];
    } else tempId = item.id;
    const date = dayjs(item.start_time).format('M/D/YYYY');
    const { dayTypeName } = resource.dayTypes[item.id];
    const { dayOffRequestTitle, dayTypeComment, myDayTypeComment } = resource.dayTypes[item.id].dayOffRequest;
    itemDetails = {
      itemType: item.itemType,
      title: 'Day Type Request Details',
      dayOffRequestTitle,
      dayTypeName,
      dayType: "Day Off Request",
      date,
      dayTypeComment,
      myDayTypeComment
    };
  } else if (item.itemType === 'off-time') {
    const date = dayjs(item.start_time).format('M/D/YYYY');
    const { dayTypeName } = resource.dayTypes[item.id];
    const { abbreviation, dayTypeComment, myDayTypeComment, isApproved, wbse, showCostObjectId, costCenter } = resource.dayTypes[item.id].dayOff;
    itemDetails = {
      itemType: item.itemType,
      title: 'Day Type Details',
      dayTypeName,
      abbreviation,
      date,
      dayTypeComment,
      myDayTypeComment,
      isApproved,
      wbse,
      showCostObjectId,
      costCenter
    };
  } else if (
    item.itemType === 'tour'
    || item.itemType === 'overtime'
    || item.itemType === 'meal'
  ) {
    const tour = resource.dayTypes[item.rdtId].tour;
    const { duration, remainDuration, meal, notificationComment, tourComment, myTourComment, isApproved, tourContract,costCenter, wbse } = tour
    const initialTourTime = (dayjs.unix(tour.startTime)).utc();

    const timeOffset = 0;//dayjs().utcOffset()*-1;
    const momentStartTime = dayjs(initialTourTime).add(timeOffset, 'minute');
    const dayTypeTitle = resource.dayTypes[item.rdtId].title;
    const tourStartTime = momentStartTime.format('h:mm a, MMM Do');
    const actualDuration = momentStartTime.format('h:mma') === '12:00am' && remainDuration
      ? duration - remainDuration : duration;
    const tourEndTime = dayjs(tourStartTime, 'h:mm a, MMM Do').add(+actualDuration, 'hour').format('h:mm a, MMM Do');
    const mealStartTime = resource.dayTypes[item.rdtId].tour.meal ? (dayjs.unix(meal.mealTime)).utc().add(timeOffset, 'minute').format('h:mm a,  MMM Do') : 'N/A';
    const mealEndTime = resource.dayTypes[item.rdtId].tour.meal ? (dayjs.unix(meal.mealEndTime)).utc().add(timeOffset, 'minute').format('h:mm a, MMM Do') : 'N/A';
    itemDetails = {
      itemType: item.itemType,
      title: 'Tour Details',
      dayTypeTitle,
      tourStartTime,
      tourEndTime,
      mealStartTime,
      mealEndTime,
      notificationComment,
      tourComment,
      myTourComment,
      isApproved,
      tourContract,
      costCenter,
      wbse
    };
  }
  return itemDetails;
}

export default generateItemDetails;
